import get from "lodash/get";
import { createSelector } from "reselect";
import { forms } from "utils/constants";
import filter from "lodash/filter";
import { isEmpty } from "lodash";

export const popStations = state => get(state, "api.popStations.data", {});
export const selfPickupStationsDomain = state =>
  get(state, "api.selfPickupStations.data", {});
export const selfPickupStationsAddressDomain = state => {
  return get(state, "api.selfPickupStationsAddress.data", {});
};
export const retailStoresDomain = state =>
  get(state, "api.retailStores.data", {});
export const shippingMethodsDomain = state =>
  get(state, "api.shippingMethods.data", {});
export const shippingLocationDetailsDomain = state =>
  get(state, "api.shippingLocationDetails.data", {});
export const shippingMethodDetailsOrderDomain = state =>
  get(state, "api.order.data", {});
export const shippingMethodDetailsGuestOrderDomain = state =>
  get(state, "api.guestOrder.data", {});
const selectForm = state => get(state, "form");

export const popStationsSelector = createSelector(popStations, popStations => {
  return get(popStations, "popstations", []);
});

export const selfPickupStationsSelector = createSelector(
  selfPickupStationsDomain,
  selfPickupStations => {
    return get(selfPickupStations, "pickupLocations", []);
  }
);

export const selfPickupStationsAddressSelector = createSelector(
  selfPickupStationsAddressDomain,
  selfPickupStationsAddress => {
    return get(selfPickupStationsAddress, "pickupLocations", []);
  }
);

export const shippingMethodsSelector = createSelector(
  shippingMethodsDomain,
  shippingMethods => {
    const sortedShippingmethods = get(shippingMethods, "deliveryMethods", [])
      .slice()
      .reverse();
    const shipmentMethods = filter(
      sortedShippingmethods,
      ({ status }) => status === "enabled"
    );
    return shipmentMethods;
  }
);

export const shippingMethodDetailsSelector = createSelector(
  selectForm,
  shippingMethodDetailsOrderDomain,
  shippingMethodDetailsGuestOrderDomain,
  (formStore, shippingMethodDetails, shippingMethodDetailsGuestOrder) => {
    return (
      get(formStore, `${forms.PERSONAL_DETAILS_FORM}.values.shippingMethod`) ||
      get(formStore, `${forms.DELIVERY_INFO_FORM}.values.shippingMethod`) ||
      get(shippingMethodDetails, "initialShipmentDetails.deliveryMethod", "") ||
      get(
        shippingMethodDetailsGuestOrder,
        "initial_shipment_details.deliveryMethod",
        ""
      )
    );
  }
);

export const selfPickupStationDetailsSelector = createSelector(
  selectForm,
  shippingLocationDetailsDomain,
  (formStore, shippingLocationDetails) => {
    return (
      get(
        formStore,
        `${forms.PERSONAL_DETAILS_FORM}.values.selfPickUpLocation`
      ) ||
      get(formStore, `${forms.DELIVERY_INFO_FORM}.values.selfPickUpLocation`) ||
      shippingLocationDetails
    );
  }
);

export const storeInfoFromSelfPickupStationDetailsSelector = createSelector(
  retailStoresDomain,
  storeInfo => {
    return !isEmpty(storeInfo) ? storeInfo[0] : null;
  }
);

export const popStationsDeliverySlotSelector = createSelector(
  popStations,
  popStations => {
    return get(popStations, "delivery_slots", []);
  }
);

export const makeSelectPopStations = () => popStationsSelector;
export const makeSelectSelfPickupStations = () => selfPickupStationsSelector;
export const makeSelectSelfShippingMethods = () => shippingMethodsSelector;
export const makeSelectSelfPickupStationsAddress = () =>
  selfPickupStationsAddressSelector;
export const makeSelectPopStationDeliverySlots = () =>
  popStationsDeliverySlotSelector;
export const makeSelectShippingMethodDetails = () =>
  shippingMethodDetailsSelector;
export const makeSelectSelfPickupStationDetails = () =>
  selfPickupStationDetailsSelector;
export const makeSelectStoreInfoFromSelfPickupStationDetails = () =>
  storeInfoFromSelfPickupStationDetailsSelector;
